<template>
	<button class="v-editor-image" @click="insert" :disabled="disabled">图片</button>
</template>

<script>
export default {
  props: {
    disabled: {
      default: null
    }
  },
  methods: {
    insert() {
      console.log(document.execCommand("insertImage", false, prompt("链接")));
    }
  }
};
</script>

<style lang="less">
.v-editor-image {
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/editor/image.vue